import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMetaColor = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 640 512",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M640 317.9C640 409.2 600.6 466.4 529.7 466.4C467.1 466.4 433.9 431.8 372.8 329.8L341.4 277.2C333.1 264.7 326.9 253 320.2 242.2C300.1 276 273.1 325.2 273.1 325.2C206.1 441.8 168.5 466.4 116.2 466.4C43.42 466.4 0 409.1 0 320.5C0 177.5 79.78 42.3999 183.9 42.3999C234.1 42.3999 277.7 67.0799 328.7 131.9C365.8 81.7999 406.8 42.3999 459.3 42.3999C558.4 42.3999 640 168.1 640 317.9ZM287.4 192.2C244.5 130.1 216.5 111.7 183 111.7C121.1 111.7 69.22 217.8 69.22 321.7C69.22 370.2 87.7 397.4 118.8 397.4C149 397.4 167.8 378.4 222 293.6C222 293.6 246.7 254.5 287.4 192.2ZM531.2 397.4C563.4 397.4 578.1 369.9 578.1 322.5C578.1 198.3 523.8 97.0799 454.9 97.0799C421.7 97.0799 393.8 123 360 175.1C369.4 188.9 379.1 204.1 389.3 220.5L426.8 282.9C485.5 377 500.3 397.4 531.2 397.4Z",
		fill: "#2B7CEA"
	})
});
export default SvgMetaColor;
